module.exports = __webpack_public_path__ + "img/ic_main_menu_as_active.048532b4.png";